// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BulkAssignToast-module__container___SvyUm {
  position: fixed;
  bottom: 40px;
  right: 20px;
  z-index: 60;
  pointer-events: none;
}

.BulkAssignToast-module__toast___ra94n {
  pointer-events: auto;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(24, 24, 27, 0.12), 0 1px 4px rgba(24, 24, 27, 0.06);
  font-size: 13px;
  color: #18181b;
  white-space: nowrap;
}

.BulkAssignToast-module__toastEntering___bovpf {
  animation: BulkAssignToast-module__slideUp___n70jD 0.25s ease-out both;
}

.BulkAssignToast-module__toastLeaving___nsFt7 {
  animation: BulkAssignToast-module__slideDown___bsVHx 0.15s ease-in forwards;
}

.BulkAssignToast-module__message___OXBrX {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 13px;
  line-height: 1.4;
  color: #18181b;
}

.BulkAssignToast-module__actionButton___DZboB {
  flex-shrink: 0;
  padding: 0;
  border: none;
  background: transparent;
  color: #18181b;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
  transition: opacity 0.12s ease;
}

.BulkAssignToast-module__actionButton___DZboB:hover {
  opacity: 0.7;
}

.BulkAssignToast-module__closeButton___iFzZc {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  padding: 0;
  border: none;
  background: transparent;
  color: #a1a1aa;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: color 0.12s ease;
}

.BulkAssignToast-module__closeButton___iFzZc:hover {
  color: #71717a;
}

@keyframes BulkAssignToast-module__slideUp___n70jD {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes BulkAssignToast-module__slideDown___bsVHx {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(8px);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/BulkAssignToast/BulkAssignToast.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,oBAAA;AACF;;AAEA;EACE,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,+EAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,sEAAA;AACF;;AAEA;EACE,2EAAA;AACF;;AAEA;EACE,cAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,4BAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE;IACE,UAAA;IACA,2BAAA;EACF;EAEA;IACE,UAAA;IACA,wBAAA;EAAF;AACF;AAGA;EACE;IACE,UAAA;IACA,wBAAA;EADF;EAIA;IACE,UAAA;IACA,0BAAA;EAFF;AACF","sourcesContent":[".container {\n  position: fixed;\n  bottom: 40px;\n  right: 20px;\n  z-index: 60;\n  pointer-events: none;\n}\n\n.toast {\n  pointer-events: auto;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  background: #ffffff;\n  box-shadow: 0 4px 16px rgba(24, 24, 27, 0.12), 0 1px 4px rgba(24, 24, 27, 0.06);\n  font-size: 13px;\n  color: #18181b;\n  white-space: nowrap;\n}\n\n.toastEntering {\n  animation: slideUp 0.25s ease-out both;\n}\n\n.toastLeaving {\n  animation: slideDown 0.15s ease-in forwards;\n}\n\n.message {\n  flex: 1 1 auto;\n  min-width: 0;\n  font-size: 13px;\n  line-height: 1.4;\n  color: #18181b;\n}\n\n.actionButton {\n  flex-shrink: 0;\n  padding: 0;\n  border: none;\n  background: transparent;\n  color: #18181b;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n  transition: opacity 0.12s ease;\n}\n\n.actionButton:hover {\n  opacity: 0.7;\n}\n\n.closeButton {\n  flex-shrink: 0;\n  width: 18px;\n  height: 18px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  color: #a1a1aa;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: color 0.12s ease;\n}\n\n.closeButton:hover {\n  color: #71717a;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 1;\n    transform: translateY(0);\n  }\n\n  to {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `BulkAssignToast-module__container___SvyUm`,
	"toast": `BulkAssignToast-module__toast___ra94n`,
	"toastEntering": `BulkAssignToast-module__toastEntering___bovpf`,
	"slideUp": `BulkAssignToast-module__slideUp___n70jD`,
	"toastLeaving": `BulkAssignToast-module__toastLeaving___nsFt7`,
	"slideDown": `BulkAssignToast-module__slideDown___bsVHx`,
	"message": `BulkAssignToast-module__message___OXBrX`,
	"actionButton": `BulkAssignToast-module__actionButton___DZboB`,
	"closeButton": `BulkAssignToast-module__closeButton___iFzZc`
};
module.exports = ___CSS_LOADER_EXPORT___;
